var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('th',[_vm._v("Culturetest")]),_c('th',[_vm._v("Culturedate")]),_c('th',[_vm._v("Cultureres")])])
}
var staticRenderFns = []

export { render, staticRenderFns }